@use 'vars';

.iq-result {
  position: relative;
  &-without-feedback {
    width: 100%;
    margin-top: -10px;
    white-space: pre-line;

    &__description {
      margin-bottom: 20px;
    }
  }

  &-with-feedback {
    display: flex;
    flex-direction: column;
    white-space: pre-line;
    gap: vars.$gap-medium;
    border: vars.$border-size-thin solid vars.$mid-grey;
    border-radius: vars.$border-radius-xlarge vars.$border-radius-large vars.$border-radius-large 0;
    padding: vars.$padding-large;
    width: 100%;
    z-index: vars.$z-index-large;
    background-color: vars.$white;
    margin: 0 auto;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.08),
      0 6px 24px 0 rgba(0, 0, 0, 0.05);
  }

  &-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: vars.$gap-medium;

    &__button {
      background-color: vars.$ai-primary !important;

      &:hover {
        background-color: darken(vars.$ai-primary, 10%) !important;
      }
    }
  }
}
